import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ErrorState, LoadingState } from "@/components/ui/page-state";
import { getUserFacingError } from "@/lib/api/errors";
import { useT } from "@/lib/i18n";
import { DEFAULT_CLIENT_ROUTE } from "@/lib/navigation";
import { useAuth } from "./auth-context";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const t = useT();
  const location = useLocation();

  if (auth.status === "unknown") {
    return <main className="container page">{auth.error ? <ErrorState message={getUserFacingError(auth.error)} onRetry={() => void auth.refreshSession().catch(() => undefined)} /> : <LoadingState label={t("common.restoring_session")} />}</main>;
  }

  if (auth.status === "unauthenticated") {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/auth/login" replace state={{ from }} />;
  }

  return children;
}

export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const t = useT();

  if (auth.status === "unknown") {
    return <main className="container page">{auth.error ? <ErrorState message={getUserFacingError(auth.error)} onRetry={() => void auth.refreshSession().catch(() => undefined)} /> : <LoadingState label={t("common.checking_session")} />}</main>;
  }

  if (auth.status === "authenticated") return <Navigate to={DEFAULT_CLIENT_ROUTE} replace />;
  return children;
}
